import React from "react";
import { Icon } from "@chakra-ui/react";

export const JobSidebarIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 53 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M31.5815 20.3055L32.0497 16.8692C33.0925 16.217 34.0841 15.486 35.0154 14.6824C38.5617 11.6225 39.542 8.95624 41.7271 8.90314C42.2641 8.89064 43.0695 9.03122 44.0684 9.84031C43.9261 10.508 43.6615 11.1435 43.2881 11.7147C43.0639 12.0554 42.8021 12.3698 42.5076 12.6518C42.5607 12.6909 43.5517 13.4484 43.4441 14.5262C43.341 15.554 42.2828 16.4583 40.9466 16.4005L38.9175 15.9319L37.981 20.9301C36.9602 23.2466 36.0237 25.3037 35.1714 27.178C34.9561 27.6466 34.6127 28.376 33.9228 28.5837C32.9191 28.8852 31.7562 27.9168 31.2693 27.3341C29.2839 24.96 31.4565 20.5522 31.5815 20.3055Z"
        fill="white"
      />
      <path
        d="M32.0497 7.65358C31.789 7.36462 30.7262 6.18534 31.1132 4.84206C31.1569 4.68587 31.3708 3.9455 32.0497 3.59251C33.0783 3.05675 34.4815 3.77681 35.1714 4.68587C35.265 4.81083 36.161 6.03072 35.6398 7.3412C35.5945 7.45678 35.1153 8.60636 34.0788 8.74696C33.1423 8.8719 32.4462 8.09404 32.0497 7.65358Z"
        fill="white"
      />
      <path
        d="M29.3962 7.65359C29.7271 7.55205 30.4232 7.34119 31.113 7.65359C32.0901 8.08781 32.7192 9.39829 32.5178 10.4651C32.2463 11.913 30.6698 11.7225 29.3962 13.9014C28.8202 14.8854 28.8888 15.3587 28.1474 16.0882C27.8024 16.4287 26.9893 17.2284 25.8061 17.1815C25.0256 17.1503 23.9752 16.741 23.6208 15.9319C23.3962 15.4181 23.5101 14.8823 26.2744 10.7775C27.5231 8.93594 28.174 8.03002 29.3962 7.65359Z"
        fill="white"
      />
      <path
        d="M26.1855 17.0096C26.7057 17.058 27.2265 16.9255 27.6606 16.6347C28.0929 16.3402 28.4113 15.9064 28.5628 15.4055"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.3255 9.54192L31.917 6.73041C31.3207 6.40396 30.5231 6.71324 30.1377 7.42079L26.2354 13.0704C25.8405 13.792 26.0263 14.6464 26.646 14.9588L29.2714 17.8062C29.8442 18.0952 30.5887 17.8155 30.9884 17.1658L34.6719 11.4881C35.0996 10.7665 34.85 10.0339 34.3255 9.54192Z"
        fill="#87A0C6"
      />
      <path
        d="M31.3476 7.41925L26.821 13.6671L29.6306 17.1034L34.157 10.5432L31.5036 7.73163"
        fill="#355C8C"
      />
      <path
        d="M40.8751 13.2469C42.0722 11.4726 42.2111 10.4807 42.2487 10.0278C42.3016 9.3889 42.3938 8.28929 41.7194 7.37242C40.6144 5.87919 38.2496 5.96666 36.9511 6.31185C36.3672 6.46806 35.1061 6.81324 34.2975 7.90348C33.8293 8.52826 33.7279 9.18428 33.2424 9.27332C32.5572 9.4014 32.0077 8.2846 31.6487 8.43298C31.4271 8.52514 31.3178 9.06871 31.6487 10.8181C30.9167 11.9115 30.0082 13.6765 30.0597 15.8554C30.08 16.6989 30.105 17.4002 30.5888 17.9749C31.7127 19.3088 34.3663 18.8591 35.8864 18.2405C37.5581 17.561 38.4245 16.449 40.1258 14.2638C40.41 13.8983 40.6565 13.5578 40.8703 13.2422"
        fill="white"
      />
      <path
        d="M12.3376 42.8616C12.4457 43.1133 12.4995 43.3851 12.4955 43.6591C12.4915 43.9331 12.4297 44.2032 12.314 44.4517C12.2872 44.505 12.2809 44.5663 12.2964 44.624C12.312 44.6816 12.3483 44.7315 12.3984 44.764C12.4512 44.793 12.5129 44.8005 12.571 44.7851C12.6291 44.7696 12.6792 44.7325 12.7105 44.6813C12.8635 44.3592 12.9448 44.0079 12.9488 43.6514C12.9528 43.2949 12.8795 42.9418 12.734 42.6163C12.7024 42.5629 12.651 42.5243 12.591 42.5088C12.5312 42.4933 12.4675 42.5021 12.414 42.5336C12.3633 42.5656 12.3265 42.6154 12.311 42.6733C12.2953 42.7312 12.302 42.7928 12.3297 42.8459L12.3376 42.8616Z"
        fill="#A24A2F"
      />
      <path
        d="M12.5465 42.6413C12.5278 42.6257 12.5294 42.6289 12.5465 42.6413C12.5596 42.6509 12.5721 42.6613 12.584 42.6725C12.6068 42.6911 12.6288 42.7109 12.6496 42.7319C12.6886 42.7709 12.726 42.8116 12.7619 42.8553L12.7852 42.8866L12.8337 42.9599C12.8649 43.01 12.8931 43.0615 12.9195 43.1162C12.9238 43.1285 12.9291 43.1405 12.9352 43.1521C12.9227 43.1177 12.9509 43.1833 12.9352 43.1521C12.9477 43.1865 12.9555 43.2068 12.9648 43.2349C12.9835 43.2908 12.9992 43.3476 13.0116 43.4052C13.0116 43.4348 13.0225 43.4629 13.0273 43.4925C13.0273 43.4521 13.032 43.5223 13.0273 43.4925C13.0273 43.5332 13.0273 43.5191 13.0273 43.5316C13.0312 43.5935 13.0312 43.6556 13.0273 43.7175C13.0273 43.7796 13.052 43.8393 13.0958 43.8833C13.1398 43.9271 13.1993 43.9517 13.2614 43.9517C13.3232 43.9506 13.3819 43.9255 13.4256 43.8818C13.4692 43.8381 13.4944 43.7793 13.4955 43.7175C13.5027 43.4308 13.4406 43.1466 13.3145 42.889C13.1884 42.6316 13.002 42.4084 12.7713 42.2383C12.7177 42.2071 12.6539 42.1985 12.5939 42.2143C12.5339 42.2301 12.4825 42.269 12.4513 42.3226C12.424 42.3759 12.4176 42.4375 12.4331 42.4953C12.4486 42.553 12.4852 42.6028 12.5356 42.6351L12.5465 42.6413Z"
        fill="#A24A2F"
      />
      <path
        d="M31.1133 4.9092C31.1023 4.76706 31.0306 3.50344 31.9671 2.90677C32.9722 2.26482 34.1179 3.03173 34.2319 3.10983C34.4317 3.24728 34.825 3.52843 34.8984 4.01421C34.9717 4.49997 34.7048 5.0529 34.4613 5.05915C34.2178 5.06539 33.94 4.5109 33.8791 4.01421C33.6746 2.37571 35.7381 0.988698 35.7803 0.963708L35.8255 0.935588L35.9659 0.852806C36.4763 0.56853 37.7189 -0.00314477 38.9754 0.540415C39.9119 0.940274 40.5909 1.78999 41.0669 2.70371C41.5431 3.61746 41.8474 4.61399 42.2531 5.56053C43.068 7.43488 44.0685 8.19867 44.0685 9.84029C44.0685 10.3089 43.9123 11.0899 43.132 11.8708"
        fill="white"
      />
      <path
        d="M31.1133 4.9092C31.1023 4.76706 31.0306 3.50344 31.9671 2.90677C32.9722 2.26482 34.1179 3.03173 34.2319 3.10983C34.4317 3.24728 34.825 3.52843 34.8984 4.01421C34.9717 4.49997 34.7048 5.0529 34.4613 5.05915C34.2178 5.06539 33.94 4.5109 33.8791 4.01421C33.6746 2.37571 35.7381 0.988698 35.7803 0.963708L35.8255 0.935588L35.9659 0.852806C36.4763 0.56853 37.7189 -0.00314476 38.9754 0.540415C39.9119 0.940274 40.5909 1.78999 41.0669 2.70371C41.5431 3.61746 41.8474 4.61399 42.2531 5.56053C43.068 7.43488 44.0685 8.19867 44.0685 9.84029C44.0685 10.3089 43.9123 11.0899 43.132 11.8708"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.0445 8.43457C36.4936 9.11091 36.3624 9.39361 36.0112 10.2152"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.2352 7.65363C33.8417 8.25342 33.4547 9.07345 33.0645 9.29369"
        stroke="black"
        strokeWidth="0.662133"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M33.0533 9.29361C32.8223 9.11086 32.6709 8.84534 32.4602 8.64071C32.2495 8.4361 31.9186 8.29396 31.661 8.43766C31.4316 8.56417 31.3597 8.85626 31.3364 9.11711C31.2724 9.82466 31.366 10.0996 31.6813 10.7369"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.6812 10.7368C31.1849 11.1132 29.6911 14.5542 30.1297 16.6566C30.2477 17.2601 30.5402 17.8158 30.9709 18.2545C31.3426 18.6157 31.8258 18.8398 32.3413 18.8902"
        stroke="black"
        strokeWidth="0.537982"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M33.4544 8.74695C33.4435 8.56108 34.959 6.50242 36.4701 5.80578C37.1664 5.50431 37.936 5.41362 38.6834 5.54494C38.9034 5.5715 38.4898 6.68204 38.6053 7.49738C38.7254 8.35022 39.3966 8.92502 40.6344 9.68412C41.8722 10.4432 40.2691 11.9974 40.0101 12.3394"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.1985 12.3629C36.5274 12.6027 36.7818 12.9309 36.9321 13.3094C37.0815 13.6858 37.1954 14.0754 37.2724 14.4731"
        stroke="black"
        strokeWidth="0.5632"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.8936 13.4328C33.5449 13.6967 34.828 13.4078 36.3436 12.7018"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.8936 13.4328C32.0793 14.4324 32.2838 15.4743 32.9409 16.2802C33.1376 16.5516 33.4204 16.7482 33.7432 16.8378C34.0057 16.8823 34.2755 16.8548 34.5236 16.7583C35.1848 16.5168 35.7504 16.068 36.136 15.4789C36.5044 14.9063 36.7652 14.2711 36.9056 13.6046"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M32.1716 13.6187C32.2451 13.9311 33.7668 14.6824 34.7033 14.5262C35.4011 14.4106 36.2643 13.8139 36.7324 13.2766"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M40.0104 12.3395C42.0395 11.8709 43.2648 12.9846 43.4177 13.9014C43.4867 14.3444 43.3971 14.7974 43.1649 15.1807C42.8097 15.7313 42.2553 16.1231 41.618 16.274C41.3465 16.3428 40.0104 16.5599 38.9177 15.7789"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.981 19.8369C38.0075 18.9654 38.7816 15.9444 38.9174 15.7758"
        stroke="black"
        strokeWidth="0.5632"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.986 14.3559C23.7055 12.6173 24.6444 10.978 25.7799 9.47793C27.6186 7.06628 28.5239 6.97881 28.9546 7.03972C29.0296 7.05066 29.7164 7.15375 29.8444 7.58172C29.9724 8.0097 29.4823 8.51889 29.3356 8.66572C29.0077 9.00778 28.8672 8.94061 28.3194 9.34361C27.9476 9.62154 27.6074 9.93948 27.3048 10.2917C27.0524 10.5694 26.8188 10.8637 26.6056 11.1726L26.4151 11.51C26.1592 15.3462 24.4874 15.3274 22.9407 16.3037"
        fill="white"
      />
      <path
        d="M22.986 14.3559C23.7055 12.6173 24.6444 10.978 25.7799 9.47793C27.6186 7.06628 28.5239 6.97881 28.9546 7.03972C29.0296 7.05066 29.7164 7.15375 29.8444 7.58172C29.9724 8.0097 29.4823 8.51889 29.3356 8.66572C29.0077 9.00778 28.8672 8.94061 28.3194 9.34361C27.9476 9.62154 27.6074 9.93948 27.3048 10.2917C27.0524 10.5694 26.8188 10.8637 26.6056 11.1726L26.4151 11.51C26.1592 15.3462 24.4874 15.3274 22.9407 16.3037"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.727 14.2138L40.01 14.5262"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M33.0645 10.7541L32.5181 10.1527"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M40.1662 21.7252C39.8591 21.6311 39.5463 21.557 39.2297 21.5034C38.9175 20.6178 38.6054 20.1492 38.2932 19.5244C36.4201 21.5549 35.6396 22.3359 34.0788 23.4293C33.8947 24.2618 33.4825 25.252 33.2983 26.0847L32.5179 23.5855C32.2572 22.6484 31.842 19.993 31.5814 19.0559C31.3067 19.3573 30.4887 19.993 30.0206 20.9301C27.5231 20.9301 24.6495 19.7853 21.4358 24.8351C21.1236 25.3317 24.4513 19.4495 26.2745 17.3376C26.2011 17.0736 25.7156 15.4243 24.0892 14.6824C23.4531 14.398 22.7523 14.2901 22.0601 14.37C21.147 15.0666 13.2396 26.1845 12.5388 28.1152C11.9145 29.8333 12.4124 32.4372 14.8801 32.9572C17.8457 33.582 19.8748 33.1135 23.6209 31.5514L25.7219 45.2967H33.214C33.3428 45.2831 33.4731 45.2936 33.598 45.3279H41.4711C41.9767 45.6404 42.2967 46.0744 42.3795 46.4384C42.4419 46.7087 42.6729 47.2053 42.3795 47.549C42.0518 47.9331 41.5991 48.1738 41.5601 48.3815C41.5241 48.5517 41.61 48.144 42.6526 48.6579C44.379 48.0738 46.1491 47.6037 47.8316 46.9055C51.7166 45.2967 53.0793 44.2032 52.6532 41.3917C52.2676 38.8583 51.0532 34.6754 50.1558 32.1762C47.9705 26.0847 45.7854 23.898 40.1662 21.7252ZM42.9398 43.4645C43.7999 40.5234 43.4439 36.3935 43.4439 32.9572C43.6267 35.4564 44.3806 38.8927 45.0049 41.3917L42.9398 43.4645Z"
        fill="#ECA789"
      />
      <path
        d="M34.2351 23.7418C34.8783 24.8562 35.4442 26.0138 35.9285 27.2062C36.5965 25.4721 37.5073 23.8418 38.6335 22.3641"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.362 23.898C32.092 24.9804 31.5395 26.2517 31.2694 27.3341C30.8276 25.5489 30.4889 23.5855 30.0208 21.5549"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1013 43.3442C45.3685 44.1118 46.2852 45.3452 46.6549 46.7806"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.6844 23.117C21.1768 24.9912 21.6606 24.6149 20.031 27.0218"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.2678 17.8063C19.7169 17.6656 20.1894 17.6157 20.6581 17.6599C21.1265 17.7039 21.5816 17.8408 21.9968 18.0626C22.4118 18.2845 22.7787 18.5869 23.0758 18.952C23.3728 19.3173 23.5942 19.7381 23.7272 20.1898"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M33.4095 27.1467C33.2987 34.3629 33.4969 36.6746 33.767 43.1099"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.9761 32.4887C43.4833 34.6754 43.4786 34.9159 44.2247 37.4869"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M23.3091 28.2416C23.3091 29.4506 23.4651 30.302 23.6212 31.5514"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.0894 57.9485C27.1799 55.5634 30.578 53.2799 33.6686 50.8932L25.4942 49.3031"
        fill="#355C8C"
      />
      <path
        d="M25.3148 49.8263C27.169 50.2684 29.8039 50.8666 31.6581 51.3085L30.333 52.3754C28.833 51.9333 26.5509 51.3351 25.0493 50.8932"
        fill="#87A0C6"
      />
      <path
        d="M25.182 51.5446C25.7112 51.721 26.7803 52.0428 27.311 52.2193L26.5164 53.0143C26.2512 52.9254 25.2912 52.727 25.0259 52.6378"
        fill="#87A0C6"
      />
      <path d="M27.8354 52.4816L27.041 53.2781L28.3661 53.8077L29.4244 53.0127" fill="#87A0C6" />
      <path
        d="M28.3707 54.0749L26.6037 53.5437L25.7219 54.3387L27.1922 54.8698L28.3707 54.0749Z"
        fill="#87A0C6"
      />
      <path d="M24.8696 54.6044L26.4586 55.137L24.8696 56.4599V54.6044Z" fill="#87A0C6" />
      <path
        d="M26.2513 53.5437L24.511 52.8909L24.1316 53.8093L25.2726 54.3232C25.2836 54.3278 25.2956 54.3294 25.3074 54.3278C25.3193 54.3262 25.3305 54.3213 25.3398 54.3137L26.2513 53.5437Z"
        fill="#87A0C6"
      />
      <path
        d="M2.41668 34.4613C1.61439 40.3313 0.811588 46.1964 0.00825949 52.0569C-0.0223645 52.2812 0.0328357 52.5089 0.162788 52.6941C0.29274 52.8796 0.487859 53.009 0.709091 53.0565L23.5789 57.9781C23.7 58.0042 23.8253 58.005 23.9466 57.9802C24.068 57.9554 24.1829 57.9057 24.2842 57.8341C24.3853 57.7628 24.4706 57.6709 24.5346 57.5649C24.5986 57.4588 24.64 57.3404 24.656 57.2175L27.0675 38.8927C27.0973 38.6644 27.0383 38.4332 26.9026 38.2471C26.7669 38.0612 26.565 37.9343 26.3386 37.893L3.46716 33.7007C3.34797 33.6789 3.2256 33.6815 3.10744 33.7084C2.98928 33.7351 2.87776 33.7855 2.7796 33.8567C2.68144 33.9277 2.59869 34.018 2.53632 34.1218C2.47394 34.2258 2.43325 34.3413 2.41668 34.4613Z"
        fill="#355C8C"
      />
      <path
        d="M11.4462 42.7975C11.4742 42.7365 12.0486 41.5261 13.3192 41.3917C14.404 41.2776 15.2953 42.0165 15.6606 42.7975C16.2147 43.9767 15.7822 45.7168 14.4118 46.2338C13.2584 46.6695 11.8473 46.0853 11.29 44.828L13.3192 43.7346L11.4462 42.7975Z"
        fill="#87A0C6"
      />
      <path
        d="M32.362 45.2967C32.9143 45.1109 33.5023 45.0573 34.0789 45.1404C34.7455 45.0701 37.2429 44.8093 39.6981 44.6719C40.2381 44.6137 40.7829 44.7228 41.2589 44.9842C41.8151 45.3399 42.2081 45.9015 42.3516 46.5461C42.3781 46.6773 42.5357 47.5412 42.0394 48.2644C41.5711 48.9437 40.6815 49.1421 38.9177 49.514C37.4036 49.8263 36.898 49.7732 36.2642 50.2949C36.0847 50.4433 35.8303 50.8119 35.3277 51.5445C34.2508 53.1157 34.0057 53.6781 33.4546 53.7313C33.1861 53.7578 32.8194 53.6657 32.6743 53.4188C32.6212 53.3298 32.5665 53.1673 32.6743 52.794C32.8149 52.3138 33.085 51.8815 33.4546 51.5445C33.4828 51.5679 32.4058 53.2797 31.7377 53.1065C31.4583 53.033 31.2695 52.6378 31.2695 52.3255C31.2554 51.7287 31.8765 51.218 31.8938 51.2321C31.7026 51.6457 31.3706 51.978 30.9573 52.1692C30.8495 52.2146 30.3689 52.4161 30.0207 52.1692C29.9277 52.0929 29.8519 51.9978 29.7981 51.8901C29.7442 51.7825 29.7138 51.6647 29.7085 51.5445C29.6711 50.9556 30.2143 50.4839 30.1769 50.4511C30.1394 50.4183 29.3356 51.5445 28.7721 51.3882C28.4599 51.3071 28.3335 50.8729 28.3037 50.7634C28.1477 50.1917 28.4239 49.6201 29.7085 47.9519C31.4333 45.7106 31.9405 45.442 32.362 45.2967Z"
        fill="white"
      />
      <path
        d="M33.2424 48.7986L31.4256 52.013C31.3439 52.1722 31.314 52.353 31.3399 52.5299C31.366 52.7069 31.4466 52.8714 31.5708 53.0002C31.6492 53.0746 31.7442 53.1291 31.8479 53.1592C31.9516 53.1895 32.061 53.1944 32.1671 53.1736C32.3903 53.1205 32.5056 52.9392 32.7101 52.6112C33.4751 51.3883 34.6239 49.5546 34.5474 49.5139C34.5021 49.489 34.0791 50.1466 32.6743 52.6378C32.6157 52.7597 32.5852 52.8931 32.5852 53.0283C32.5852 53.1635 32.6157 53.297 32.6743 53.4187C32.8959 53.8015 33.4344 53.8483 33.7669 53.7312C34.0994 53.6141 34.2616 53.3095 34.5192 52.7941C35.4744 50.8869 36.4423 49.9826 36.6373 49.9715C37.5954 49.9624 38.5482 49.8291 39.4719 49.5749C39.9322 49.437 40.3802 49.261 40.8111 49.0485C41.1831 48.8663 41.5415 48.6575 41.8834 48.4237"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.7475 51.1322C29.6841 51.2875 29.6651 51.4574 29.6928 51.6229C29.7203 51.7883 29.7933 51.943 29.9037 52.0693C30.0366 52.2125 30.2144 52.3059 30.4077 52.3344C30.6009 52.3627 30.7981 52.3243 30.9665 52.2254L33.247 48.8018"
        stroke="black"
        strokeWidth="0.5632"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.4597 51.0758C28.538 51.1667 28.6335 51.2411 28.7405 51.2947C28.8477 51.3483 28.9645 51.3802 29.084 51.3882C29.3962 51.3882 29.6194 51.1571 29.8988 50.8213C30.6309 49.9434 30.9914 49.2139 31.6032 48.308C31.7844 48.0394 31.9357 47.8301 32.0263 47.7083"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0789 45.1403C32.6741 45.1403 32.1496 45.423 31.7376 45.609C31.1367 45.8808 30.3906 46.9694 28.928 49.1358C28.928 49.1358 28.2288 50.1621 28.3864 50.9774"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.698 44.6718C40.1929 44.5886 40.7014 44.665 41.1502 44.8895C41.599 45.1141 41.965 45.4754 42.1954 45.9214C42.3802 46.3082 42.4561 46.7379 42.4148 47.1645C42.3735 47.5912 42.2167 47.9984 41.9614 48.3426"
        stroke="black"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </Icon>
  );
};
